import React, { useContext, useEffect, useState } from 'react';

import { Field } from 'formik'
import { TextField } from 'formik-material-ui'
import './../../../form.css'

import {
    Grid,
    Typography,
    Card,
    CardContent,
    CardHeader,
    Divider
} from '@material-ui/core';

import {
    Select,
    FieldError
} from '../../../../common'

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { SettingsContext } from '../../../../contexts/SettingsContext';
import { TabsContext } from '../TabsContext';
import { UserContext } from '../../../../contexts/UserContext';
import { SapTableNames } from '../../../../../helpers';
import { makeStyles } from '@material-ui/core/styles';
import { percentageField } from '../../../../../helpers/Utils';
import { ApplicationRoles, DbType, RequestStatus } from '../../../../../helpers/Common';

const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
}));

export const PricingForm = (props) => {
    const classes: any = useStyles();

    const {
        state,
        getTableOptionsWithCode
    } = useContext(CustomerRequestContext);

    const { values } = useContext(TabsContext);
    const { appSettingsS4, appSettingsECC } = useContext(SettingsContext);
    const { isUserInRole } = useContext(UserContext);

    const [isPerfume, setIsPerfume] = useState(false);
    const [isMandatoryPG, setIsMandatoryPG] = useState(true);

    useEffect(() => {
        if (
            values !== null &&
            values.salesOrganizationId &&
            state.userSalesOrgs.length > 0
        ) {
            const is002P = !state.userSalesOrgs.some(x =>
                values.salesOrganizationId === x.tableValueId &&
                x.externalKey === "002P"
            );

            setIsMandatoryPG(is002P);
        }
    }, [values]);

    useEffect(() => {
        if (values !== null && appSettingsECC !== null){
            const perfumeBC = appSettingsECC.find(x => x.appSettingKey === "PerfumesBusinessCategoryId");

            if (perfumeBC && Number(perfumeBC.value) === values.businessCategoryId)
                setIsPerfume(true);
        }
    }, [values, appSettingsECC]);

    useEffect(() => {
        if (values !== null && appSettingsS4 !== null){
            const perfumeBC = appSettingsS4.find(x => x.appSettingKey === "PerfumesBusinessCategoryId");

            if (perfumeBC && Number(perfumeBC.value) === values.businessCategoryId)
                setIsPerfume(true);
        }
    }, [values, appSettingsS4]);

    const pricingUnitFieldsVisibility: boolean = state.request.dbType === DbType.S4 && (
        state.request.status === RequestStatus.PricingUnit ||
        state.request.status === RequestStatus.AccountReceivableApproval ||
        state.request.status === RequestStatus.WaitingToBeAddedInSap ||
        state.request.status === RequestStatus.Approved ||
        state.request.status === RequestStatus.SapError
    );

    const pricingUnitFieldsEditability = state.request.dbType === DbType.ECC ? props.disabled : !(state.request.status === RequestStatus.PricingUnit && isUserInRole(ApplicationRoles.PricingUnit));

    return (
        <Card className={classes.card}>
            <CardHeader title="Pricing information" />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xl={12} md={12} xs={12}>
                        <Typography variant="h6">
                            Customer margin (%)
                        </Typography>
                    </Grid>

                    {
                        isPerfume ?
                            <>
                                <Grid item xl={4} md={12} xs={12}>
                                    <Field
                                        className={classes.field}
                                        variant="outlined"
                                        name="resaleMargins.perfume"
                                        label="Perfume *"
                                        disabled={props.disabled}
                                        component={percentageField}
                                    />
                                    <FieldError name="resaleMargins.perfume" errors={state.errors} />
                                </Grid>

                                {
                                    state.request.dbType === DbType.S4 &&
                                    <Grid item xl={4} md={12} xs={12}>
                                        <Field
                                            className={classes.field}
                                            variant="outlined"
                                            name="resaleMargins.perfumesKit"
                                            label="Perfumes Kit *"
                                            disabled={props.disabled}
                                            component={percentageField}
                                        />
                                        <FieldError name="resaleMargins.perfumesKit" errors={state.errors} />
                                    </Grid>
                                }
                            </> :
                            <>
                                <Grid item xl={4} md={12} xs={12}>
                                    <Field
                                        className={classes.field}
                                        variant="outlined"
                                        name="resaleMargins.jewellery"
                                        label="Jewellery"
                                        disabled={props.disabled}
                                        component={percentageField}
                                    />
                                    <FieldError name="resaleMargins.jewellery" errors={state.errors} />
                                </Grid>
                                <Grid item xl={4} md={12} xs={12}>
                                    <Field
                                        className={classes.field}
                                        variant="outlined"
                                        name="resaleMargins.watches"
                                        label="Watches"
                                        disabled={props.disabled}
                                        component={percentageField}
                                    />
                                    <FieldError name="resaleMargins.watches" errors={state.errors} />
                                </Grid>
                                <Grid item xl={4} md={12} xs={12}>
                                    <Field
                                        className={classes.field}
                                        variant="outlined"
                                        name="resaleMargins.accessories"
                                        label="Accessories"
                                        disabled={props.disabled}
                                        component={percentageField}
                                    />
                                    <FieldError name="resaleMargins.accessories" errors={state.errors} />
                                </Grid>

                                {
                                    state.request.dbType === DbType.S4 &&
                                    <>
                                        <Grid item xl={4} md={12} xs={12}>
                                            <Field
                                                className={classes.field}
                                                variant="outlined"
                                                name="resaleMargins.hewMargin"
                                                label="HEW Margin"
                                                disabled={props.disabled}
                                                component={percentageField}
                                            />
                                        </Grid>

                                        <Grid item xl={4} md={12} xs={12}>
                                            <Field
                                                className={classes.field}
                                                variant="outlined"
                                                name="resaleMargins.hjMargin"
                                                label="HJ Margin"
                                                disabled={props.disabled}
                                                component={percentageField}
                                            />
                                            <FieldError name="resaleMargins.hjMargin" errors={state.errors} />
                                        </Grid>
                                    </>
                                }
                            </>
                    }
                    <Divider style={{ width: "100%" }} />
                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            multiline
                            variant="outlined"
                            type="text"
                            name="customerMarginNote"
                            label="Customer margin note"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="customerMarginNote" errors={state.errors} />
                    </Grid>
                    <Divider style={{ width: "100%" }} />
                    <Grid item xl={12} md={12} xs={12}>
                        <Typography variant="subtitle1">
                            Pricing
                        </Typography>
                    </Grid>

                    {
                        state.request.dbType === DbType.ECC ?
                        <>
                            <Grid item xl={6} md={12} xs={12}>
                                <Select
                                    name="pricingListId"
                                    label="Pricing List *"
                                    disabled={props.disabled}
                                    options={getTableOptionsWithCode(SapTableNames.PricingLists, values.dbType)}
                                />
                                <FieldError name="pricingListId" errors={state.errors} />
                            </Grid>

                            <Grid item xl={6} md={12} xs={12}>
                                <Select
                                    name="pricingGroupId"
                                    label={`Pricing group${isMandatoryPG ? " *" : ""}`}
                                    disabled={props.disabled}
                                    options={getTableOptionsWithCode(SapTableNames.PricingGroups, values.dbType)}
                                />
                                <FieldError name="pricingGroupId" errors={state.errors} />
                            </Grid>
                        </> :
                        pricingUnitFieldsVisibility &&
                        <>
                            <Grid item xl={6} md={12} xs={12}>
                                <Select
                                    name="pricing.pricingListId"
                                    label="Pricing List *"
                                    disabled={pricingUnitFieldsEditability}
                                    options={getTableOptionsWithCode(SapTableNames.PricingLists, values.dbType)}
                                />
                                <FieldError name="pricing.pricingListId" errors={state.errors} />
                            </Grid>

                            <Grid item xl={6} md={12} xs={12}>
                                <Select
                                    name="pricing.pricingGroupId"
                                    label={`Pricing group${/*isMandatoryPG ? " *" : ""*/" *"}`}
                                    disabled={pricingUnitFieldsEditability}
                                    options={getTableOptionsWithCode(SapTableNames.PricingGroups, values.dbType)}
                                />
                                <FieldError name="pricing.pricingGroupId" errors={state.errors} />
                            </Grid>
                        </>
                    }

                    <Grid item xl={12} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            multiline
                            variant="outlined"
                            type="text"
                            name="pricingNote"
                            label="Pricing note"
                            disabled={props.disabled}
                            component={TextField}
                        />
                        <FieldError name="pricingNote" errors={state.errors} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}